// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.player-container[data-v-06202182] {\n  display: grid;\n  justify-content: center;\n  align-content: center;\n  padding: 30px 0;\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
